import contentRequest from '~/src/api/requests/contentRequest';

export function getTvChannels(citydomain) {
    return contentRequest.getWithCache(`/${citydomain}/v1/channels/channels`).then(response => {
        response.data = response.data.items;
        return response;
    });
}
